import { Button } from "matsuri-ui"
import { css } from "@emotion/react"
import { useNavigate } from "react-router-dom"

export const ResendActivationEmailFinished: Page = () => {
    const navigate = useNavigate()

    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                gap: 32px;
                text-align: center;
            `}
        >
            <h2>アクティベーションメール送信完了</h2>
            <p>
                アクティベーションメールを送信しました。
                <br />
                メールをご確認ください。
            </p>
            <Button
                variant="filled"
                color="primary"
                onClick={() => navigate("/users")}
            >
                ユーザー一覧に戻る
            </Button>
        </div>
    )
}

ResendActivationEmailFinished.path = "/resend_activation_email_finished"
